import { render, staticRenderFns } from "./subCategoryDialog.vue?vue&type=template&id=568416af&scoped=true&"
import script from "./subCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./subCategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./subCategoryDialog.vue?vue&type=style&index=0&id=568416af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568416af",
  null
  
)

export default component.exports